import React from 'react';
import Cs from '../../../services/CommonService';

const SectionCard = ({ children, extraClass = '' }) => (
  <div className={`bg-white brd-10 shadow-small p-20 m-b-20 ${extraClass}`}>{children}</div>
);

const CardHeader = ({ title, action, onAction }) => (
  <div className="flex justspacebetween aligncenter m-b-15">
    <span className="fw700 font-15 color-black">{title}</span>
    {action && <span className="font-12 highlight pointer fw500" onClick={onAction}>{action}</span>}
  </div>
);

const CompanyTab = ({orgRegistration}) => {
  const {data:regInfo={}} = orgRegistration;

  return (
    <SectionCard>
      <CardHeader title="Company Information" action="Edit" />
      <div className="flex wrap gap-20">
        {[
          ['Company Name', regInfo.name], ['Industry', 'Technology & Consulting'],
          ['Registration No.', 'REG-2010-00487'],       ['Founded', regInfo.year_formation],
          ['Website', regInfo.url],               ['Type', 'Private Limited'],
        ].map(([k, v]) => (
          <div key={k} className="wid-30 m-b-15">
            <div className="font-11 fw700 lgrey text-upp ls-1 m-b-2">{k}</div>
            <div className="font-14 dark-navy fw500">{v}</div>
          </div>
        ))}
      </div>
      <div className="br-top-grey m-t-15 p-t-15">
        <div className="font-11 fw700 lgrey text-upp ls-1 m-b-5">About</div>
        <p className="font-13">{regInfo.name} is a leading technology and consulting firm delivering innovative solutions to Fortune 500 clients across North America.</p>
      </div>
    </SectionCard>
  );
};

export default CompanyTab;